import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'archives-rdc-container';

export const JOBS = createApiConstants(NAMESPACE, 'JOBS');

export const INITIALIZED = `${NAMESPACE}/INITIALIZED`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const INCREMENT_PAGE = `${NAMESPACE}/INCREMENT_PAGE`;
export const RESET_PAGE = `${NAMESPACE}/RESET_PAGE`;
